<template>
  <v-btn @click.stop="onClick" text small>
    <v-icon id="RTE__command__undo">mdi-undo</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'undo',
  methods: {
    onClick () {
      this.$emit('click', 'undo')
    }
  }
}
</script>

<style scoped>
#RTE__command__undo {
  font-size: 20px;
}
</style>
